import { Fragment } from "react";
// wild guess @ what this does? 
const removeWhiteSpace = string => string ? string.replace(/\s/g,'') : null

// removes http(s)://www. from urls
const standardizeURL = url => url ? url.replace(/http(s)?(:)?(\/\/)?|(\/\/)?(www\.)?/g, '') : null
const sanitizeStandardizedURL = (value) => {
  if (!value || typeof value !== 'string') {
    return { ok: false, error: 'URL is required' };
  }

  const url = value.trim().toLowerCase();

  // Reject spaces
  if (/\s/.test(url)) {
    return { ok: false, error: 'URL cannot contain spaces' };
  }

  // Must contain at least one dot
  if (!url.includes('.')) {
    return { ok: false, error: 'URL must contain a domain extension' };
  }

  // Must end with a valid TLD (letters only, 2+ chars)
  if (!/\.[a-z]{2,}$/.test(url)) {
    return { ok: false, error: 'URL must end with a valid domain extension' };
  }

  return { ok: true, value: url };
}



const capitalizeEveryWord = inputString => {
  if (!inputString) { return  ''}

     const words = inputString.split(" ");
   
     const capitalizedWords = words.map((word) =>
       word.charAt(0).toUpperCase() + word.slice(1)
     );
   
     const capitalizedString = capitalizedWords.join(" ");
   
     return capitalizedString;
}



const formatString = textString => {

  if (!textString) { return ;}
  return textString?.split("\n").map(
    (line, index) => (
      <Fragment key={index}>
{processMarkdown(line)}
       <br />
      </Fragment>
    )
  )
}



const processMarkdown = textString => {
  if (!textString) { return; }

  const boldRegex = /\*\*(.*?)\*\*/g;

  return textString.split(boldRegex).map((part, partIndex) => {
    // If part matches the bold markdown, wrap it in <strong>
    if (partIndex % 2 === 1) {
      return <strong key={partIndex}>{part}</strong>;
    }
    // Otherwise, return the part as is
    return part;
  });
}





const humanizeString = textString => textString && textString.replaceAll('_', ' ').split(' ').map(x=>x.charAt(0).toUpperCase() + x.slice(1).toLowerCase()).join(' ')



const standardizeNoteCategoryName = (originalStr) => {

  if (!originalStr) { return }
  // Trim white spaces from both ends
  let trimmedStr = originalStr?.trim().toUpperCase();

  // Replace apostrophes with underscores
  let apostropheStr = trimmedStr?.replace(/'/g, "_");

  // Remove dots and commas
  apostropheStr = apostropheStr?.replace(/\./g, "");
  apostropheStr = apostropheStr?.replace(/,/g, "");

  // Replace dashes with underscores
  apostropheStr = apostropheStr?.replace(/-/g, "_");

  // Replace pluses with underscores
  apostropheStr = apostropheStr?.replace(/\+/g, "_");

  // Replace slashes with underscores
  apostropheStr = apostropheStr?.replace(/[\/\\]/g, "_");

  // Remove accents from characters
  let accentRemovedStr = apostropheStr?.normalize("NFD").replace(/[\u0300-\u036f]/g, "" );

  // Replace special characters with their equivalents
  let specialCharsReplacedStr = accentRemovedStr
    ?.replace(/[éèê]/g, 'e')
    .replace(/[àáâ]/g, 'a')
    // Add more character replacements as needed

  // Replace white spaces between words with underscores
  let standardizedStr = specialCharsReplacedStr.replace(/\s+/g, '_');

  return standardizedStr;
}




function standardizeFileName(originalFileName) {
  // Trim white spaces from both ends
  let trimmedFileName = originalFileName?.trim();

  // Replace apostrophes with underscores
  let apostropheFileName = trimmedFileName?.replace(/'/g, "_");

  // Replace dashes with underscores
  apostropheFileName = apostropheFileName?.replace(/-/g, "_");

  // Replace pluses with underscores
  apostropheFileName = apostropheFileName?.replace(/\+/g, "_");

  // Replace slashes with underscores
  apostropheFileName = apostropheFileName?.replace(/[\/\\]/g, "_");

  // Remove accents from characters
  let accentRemovedFileName = apostropheFileName?.normalize("NFD").replace(/[\u0300-\u036f]/g, "" );

  // Replace special characters with their equivalents
  let specialCharsReplacedFileName = accentRemovedFileName
    ?.replace(/[éèê]/g, 'e')
    .replace(/[àáâ]/g, 'a')
    // Add more character replacements as needed

    const words = specialCharsReplacedFileName?.split("_"); // mod to split (" ")
   
    const capitalizedWords = words?.map((word) =>
       word.charAt(0).toUpperCase() + word.slice(1)
     ).join(' ')

  // Replace white spaces between words with underscores
  let standardizedFileName = capitalizedWords?.replace(/\s+/g, '_');

  return standardizedFileName;
}



function standardizeLocationName(originalFileName) {
  // Trim white spaces from both ends
  let trimmedFileName = originalFileName?.trim();

  // Replace apostrophes with dashes
  let apostropheFileName = trimmedFileName?.replaceAll(/'/g, '-');

  // Replace dots with "dot"
  apostropheFileName = apostropheFileName?.replaceAll(/\./g, 'dot');

  // Replace spaces with dashes
  apostropheFileName = apostropheFileName?.replaceAll(' ', '-');

    apostropheFileName = apostropheFileName?.replaceAll('_', '-');

  // Replace pluses with dashes
  apostropheFileName = apostropheFileName?.replaceAll(/\+/g, '-');

  // Replace & with "and"
  apostropheFileName = apostropheFileName?.replaceAll('&', 'and');

  // Replace slashes (/ | \) with "or"
  apostropheFileName = apostropheFileName?.replaceAll(/[\/|\\]/g, 'or');

  // Replace # with Sharp
  apostropheFileName = apostropheFileName?.replaceAll('#', 'sharp');

  // Remove accents from characters
  let accentRemovedFileName = apostropheFileName
    ?.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  // Replace special characters with their equivalents
  let specialCharsReplacedFileName = accentRemovedFileName
    ?.replace(/[éèê]/g, 'e')
    .replace(/[àáâ]/g, 'a')
    .replace(/[^a-z0-9-]/gi, ''); // Remove all non-alphanumeric characters except -
  // Add more character replacements as needed

  // Split the filename into words based on spaces and replace spaces between words with underscores
  const words = specialCharsReplacedFileName?.split(/[_\s]+/); // split by space and underscore

  // Join the words back into a single string with underscores
  let standardizedFileName = words?.join('-');

  return standardizedFileName.toLowerCase();
}

// const jobLocationStrFromObj = locationObj => {
//   return `${locationObj.city}, ${locationObj.state.replaceAll('_', '-')}, ${locationObj.country}`
// }




const  standardizeHandle = (handleString) => {

  if (!handleString) { return ; }

  // Step 1: Trim white spaces from both ends
  let handle = handleString?.trim();
  handle = handle.toLowerCase();
  // Step 2: Replace special characters with their equivalents
  handle = handle
    ?.replace(/[éèê]/g, 'e')
    .replace(/[àáâ]/g, 'a');
    // Add more character replacements as needed

  // Step 3: Remove non-word characters, except spaces and hyphens
  handle = handle?.replace(/[^\w\s-]/g, '');

  // Step 4: Replace multiple spaces or underscores with a single hyphen
  handle = handle?.replace(/[\s_]+/g, '-');

  // Step 5: Remove leading and trailing hyphens or underscores
  handle = handle?.replace(/^[-_]+|[-_]+$/g, '');

  return handle;
}

const removeNumbersAndSpecialChars = (str = '') => {
  return str
    .normalize('NFD')                 // split accented chars (é → e + ́)
    .replace(/[\u0300-\u036f]/g, '')  // remove accent marks
    .replace(/[^\p{L}\s]/gu, '')      // keep letters + spaces only (Unicode-safe)
    .replace(/\s+/g, ' ')             // collapse multiple spaces
    .trim();
};

function modifyFileNameWithoutExtension(inputFileName, newPrefix) {
  // Split the original filename into prefix and extension
  const parts = inputFileName?.split('.');
  return parts?.[0]
}

const shortenFileName = (string) => {
  if (string){let arr = string?.split('.'); 
  let name = arr[0]
  let extension = arr[arr.length-1]
  return `${name.substring(0, 20)}..${extension}`}
  else { return undefined}
}
// `${string?.substring(0, 20)}...`

function formatPhoneNumber(input) {
  // Remove all non-numeric characters
  const cleaned = input.replace(/\D/g, '');

  // Check if the number starts with "1" for long distance
  const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/) || cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    // For long distance numbers, format with 1
    if (match.length === 5) {
      return `${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
    } else {
      // For regular 10-digit numbers
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
  }

  // Return the original cleaned number if it doesn't fit the format
  return cleaned;
}




function formatSocialPostBody(text) {


  function getYouTubeId(url) { // works for videos but not for shorts.
  const patterns = [
    /v=([^&]+)/,              // youtube.com/watch?v=ID
    /youtu\.be\/([^?]+)/,     // youtu.be/ID
    /embed\/([^?]+)/,          // youtube.com/embed/ID
  /shorts\/([^?]+)/       // youtube shorts
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) return match[1];
  }

  return null;
}

  /*------------------------------- 
    Detect links and output as html
  ------------------------------- */
  if (!text) return null;

  // Match URLs or domains (http(s), www., or bare domains like google.com)
  
  // const urlRegex = /\b((?:https?:\/\/|www\.)[^\s<>]+|[a-z0-9.-]+\.(?:com|net|org|io|ca|co|us|uk|edu|gov|info))\b/gi; // WORKS v1
  const urlRegex = /\b((?:https?:\/\/|www\.)[^\s<>]+|[a-z0-9.-]+\.(?:com|net|org|io|ca|co|us|uk|edu|gov|info)(?:\/[^\s<>]*)?)/gi;
  const elements = [];
  let lastIndex = 0;

  let match;
  while ((match = urlRegex.exec(text)) !== null) {
    const url = match[0];
    const offset = match.index;

    // Add text before the URL
    if (offset > lastIndex) {
      elements.push(text.slice(lastIndex, offset));
    }

    // Build href
    let href = url.startsWith('www.') ? `http://${url}` : url;
    if (!href.startsWith('http://') && !href.startsWith('https://')) {
      href = `http://${href}`;
    }

    elements.push(
      <a
        onClick={(e) => e.stopPropagation()}
        key={offset}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-teal-500 hover:underline"
      >
        {url}
      </a>
    );

    lastIndex = offset + url.length;
  }

  // Add remaining text
  if (lastIndex < text.length) {
    elements.push(text.slice(lastIndex));
  }

  return elements;






//   if (!text) return null;

//   // const urlRegex = /(\b(https?:\/\/|www\.)[^\s<>]+[^\s.,;!?"'<>])/gi;
//   const urlRegex = /(\b(https?:\/\/|www\.)[^\s<>]+[^\s.,;!?"'<>]|\b[a-z0-9.-]+\.(com|net|org|io|ca|co|us|uk|edu|gov|info)\b)/gi;
// // const urlRegex = /\b((https?:\/\/|www\.)[^\s<>]+|[a-z0-9.-]+\.(com|net|org|io|ca|co|us|uk|edu|gov|info)(\/[^\s<>]*)?)/gi;

//   const parts = text.split(urlRegex);
//   console.log("PARTS", parts)
//   return parts.map((part, i) => {
//     if (urlRegex.test(part)) {
//       const href = part.startsWith('www.') ? `http://${part}` : part;
//       return (
//         <a key={i} href={href} target="_blank" rel="noopener noreferrer" className="text-teal-500 hover:underline">
//           {part}
//         </a>
//       );
//     }
//     return part;
//   });


  // if (!text) return '';
  // // Regex to match URLs (http, https, www)
  // const urlRegex = /(\b(https?:\/\/|www\.)[^\s<>]+[^\s.,;!?"'<>])/gi;

  // return text.replace(urlRegex, (url) => {
  //   // Add http:// if the link starts with www
  //   const href = url.trim().startsWith('www.') ? `http://${url.trim()}` : url.trim();
  //   console.log("HREF", href)
  //   return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  // });


}



const getEntityLocationStr = (entityType, entityData) => {
  // console.log("ENTITYTYPE&DATA", entityType, entityData)
  const location = entityData?.[`${entityType}_location`]; // Dynamically access the location object
  const str = [
    humanizeString(location?.city),
    humanizeString(location?.state),
    humanizeString(location?.country),
  ]
    // .filter(Boolean) // Remove any falsy values
    .filter(item => item && item.trim() !== "")
    .join(", ");
  

  return str; // Return the constructed string
};
export {removeWhiteSpace, getEntityLocationStr, formatPhoneNumber, processMarkdown, standardizeURL, sanitizeStandardizedURL, capitalizeEveryWord, formatString, humanizeString, standardizeNoteCategoryName, standardizeFileName, modifyFileNameWithoutExtension, standardizeHandle, shortenFileName, standardizeLocationName, removeNumbersAndSpecialChars, formatSocialPostBody}